import { OfferAuction, OfferStatus, Vehicle } from '../types/vehicle';
import { auctionOfferStatuses } from '../utils/statusCalculator';
import {
  ADMIN_VEHICLE_STATUS,
  AUCTION_STATUSES,
  AUCTION_TYPES,
  BUYER_VEHICLE_STATUS,
  SELLER_VEHICLE_STATUS,
  VEHICLE_STATUSES
} from '../constants';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { User } from 'types/user';
import { useIsAlternativeAuction } from './useIsAlternativeAuction';

type TimerConfig = {
  timer: null | moment.Moment;
  colorsConfig: {
    active?: boolean;
    state?: boolean;
    activeColor?: string;
    staleColor?: string;
  };
};

const endStatuses = [VEHICLE_STATUSES.AWARDED, VEHICLE_STATUSES.PULLED];

const useAlternativeTimer = (vehicle: Vehicle) => {
  const user = useSelector((state: any) => state.user.user);

  if (
    !vehicle.auction ||
    vehicle.auction.type === AUCTION_TYPES.AUTOAXESS ||
    vehicle.auction.status === AUCTION_STATUSES.ENDED ||
    endStatuses.includes(vehicle.status) ||
    vehicle.role_based_statuses.admin === ADMIN_VEHICLE_STATUS.UNDECIDED
  ) {
    return {
      timer: null,
      colorsConfig: {}
    };
  }

  const parsedVehicleEnd = moment(vehicle.date_end);
  const parsedAuctionEnd = moment(vehicle.auction.date_end);

  if (vehicle.in_battle || parsedVehicleEnd.isAfter(parsedAuctionEnd)) {
    return {
      timer: parsedVehicleEnd,
      colorsConfig: {}
    };
  }

  console.log(parsedVehicleEnd.toISOString(), 'parsedVehicleEnd');
  console.log(moment().toISOString(), 'parsedNow');
  console.log(parsedAuctionEnd.toISOString(), 'parsedAuctionEnd');
  if (moment().isBetween(parsedVehicleEnd, parsedAuctionEnd)) {
    return {
      timer: parsedAuctionEnd,
      colorsConfig: {}
    };
  }

  if (vehicle.auction.type === AUCTION_TYPES.FRONTLINE) {
    return {
      timer: user.role === 'admin' ? parsedVehicleEnd : null,
      colorsConfig: {}
    };
  }

  return {
    timer: parsedVehicleEnd,
    colorsConfig: {}
  };
};

const useAaTimer = (vehicle: Vehicle, offerAuction?: OfferAuction | null) => {
  const activeOffer = offerAuction?.privateOffers?.find(offer => offer.status === OfferStatus.SENT) ?? null;
  const user = useSelector((state: any) => state.user?.user);
  const buyerResponseTime = useSelector(
    (state: any) => state.locations?.currentLocation?.buyer_response_time || 900000
  );
  const sellerResponseTime = useSelector(
    (state: any) => state.locations?.currentLocation?.seller_response_time || 900000
  );

  const status = auctionOfferStatuses(vehicle, offerAuction, user?.id ? user : null);

  const offerAuctionStatusTimerMap: Record<string, string[]> = {
    buyer: [BUYER_VEHICLE_STATUS.COUNTERED],
    admin: [
      ADMIN_VEHICLE_STATUS.ADMIN_COUNTER_SENT,
      ADMIN_VEHICLE_STATUS.SELLER_COUNTER_SENT,
      ADMIN_VEHICLE_STATUS.BUYER_COUNTER_SENT
    ],
    seller: [SELLER_VEHICLE_STATUS.BUYER_COUNTER_SENT]
  };

  if (user && activeOffer && offerAuctionStatusTimerMap[user.role].includes(status)) {
    const responseTime = activeOffer.sender?.role === 'buyer' ? sellerResponseTime : buyerResponseTime;

    return {
      timer: moment(activeOffer.created_at).add(responseTime, 'milliseconds'),
      colorsConfig: { active: true, stale: true, activeColor: '#AF2930' }
    };
  }

  if (
    !vehicle.auction ||
    endStatuses.includes(vehicle.status) ||
    vehicle.auction.status === AUCTION_STATUSES.ENDED ||
    vehicle.auction.type !== AUCTION_TYPES.AUTOAXESS
  ) {
    return {
      timer: null,
      colorsConfig: {}
    };
  }

  const isShuffled = vehicle.date_end != null;
  const timer = isShuffled ? moment(vehicle.date_end) : moment(vehicle.auction.date_end);

  return { timer, colorsConfig: {} };
};

export const useTimerConfig = (vehicle: Vehicle, offerAuction?: OfferAuction | null): TimerConfig => {
  const alternativeTimer = useAlternativeTimer(vehicle);
  const aaTimer = useAaTimer(vehicle, offerAuction);
  const isAlternativeVehicle = useIsAlternativeAuction(vehicle);

  return isAlternativeVehicle ? alternativeTimer : aaTimer;
};
